import { CircularProgress, Grid, Stack } from "@mui/material";
import { LoadingStyles } from "./styles/LoadingStyles";
export default function Loading() {
  const classes = LoadingStyles();

  //Warning Modal Const
  return (
    <Grid className={classes.container}>
      <Grid style={{ display: "flex", justifyContent: "center" }}>
        <Stack
          sx={{
            color: "#fc4c4c",
          }}
        >
          <CircularProgress
            color="inherit"
            sx={{
              width: "80px !important",
              height: "80px !important",
            }}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
